/*
  TS cart: free gift tier bar and picker for the slide-out cart (snippets/ts-cart-drawer.liquid)
  and the cart page (the mount is added under the stock line items card). Gift tiers come from #ts-gift-config, written by
  sections/ts-cart-gifts.liquid (Theme editor > Footer > Free gifts (TS)).

  Rules kept here:
  - Only 1 gift line per order. Gift lines carry the property "Promotion: Free gift".
  - The tier is picked from the subtotal of the non-gift lines.
  - A gift that is not allowed at the current tier (or any extra gift line) is removed, quantity is held at 1.
  After any change the stock theme is asked to redraw the cart with the "cart:refresh" event.

  The page lock guard at the end of the file (2026-10-21) keeps the theme's scroll lock on while the slide-out cart is open.
*/
(function () {
  if (window.tsCartGifts) return;

  var PROMO_KEY = 'Promotion';
  var PROMO_VAL = 'Free gift';
  var cartUrl = (window.routes && window.routes.cartUrl) || '/cart';
  var busy = false;
  var pending = false;
  var timer = null;
  var lastCart = null;

  function config() {
    var el = document.getElementById('ts-gift-config');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      c.tiers = (c.tiers || []).filter(function (t) { return t.amount > 0 && t.products && t.products.length; })
        .sort(function (a, b) { return a.amount - b.amount; });
      return c;
    } catch (e) { return null; }
  }

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + n.replace(/\.00$/, '.00');
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function isGift(item) {
    return !!(item.properties && item.properties[PROMO_KEY] === PROMO_VAL);
  }

  function getState(cart, conf) {
    var sub = 0;
    cart.items.forEach(function (i) { if (!isGift(i)) sub += i.final_line_price; });
    var cur = null;
    var next = null;
    conf.tiers.forEach(function (t) {
      if (sub >= t.amount) cur = t;
      else if (!next) next = t;
    });
    var allowed = {};
    if (cur) cur.products.forEach(function (p) { p.variants.forEach(function (v) { allowed[v.id] = true; }); });
    return { sub: sub, cur: cur, next: next, allowed: allowed, gifts: cart.items.filter(isGift) };
  }

  function getJSON(url, body) {
    var opts = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (body) { opts.method = 'POST'; opts.body = JSON.stringify(body); }
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function fetchCart() { return getJSON(cartUrl + '.js'); }

  function redrawTheme() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }

  // Remove extra or no longer allowed gift lines. Returns true when the cart was changed.
  function enforce(state) {
    var updates = {};
    var changed = false;
    state.gifts.forEach(function (g, idx) {
      if (idx > 0 || !state.allowed[g.variant_id]) { updates[g.key] = 0; changed = true; }
      else if (g.quantity !== 1) { updates[g.key] = 1; changed = true; }
    });
    if (!changed) return Promise.resolve(false);
    return getJSON(cartUrl + '/update.js', { updates: updates }).then(function () { return true; });
  }

  /* ---------- drawing ---------- */

  var ICON_CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var ICON_LOCK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  var ICON_GIFT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>';
  var ICON_CHEV = '<svg class="tsg-chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  function barHtml(cart, conf, st) {
    var giftsOn = conf.enabled && conf.tiers.length;
    var marks = [];
    if (conf.freeShip > 0) marks.push({ amount: conf.freeShip, label: 'Free shipping', on: cart.total_price >= conf.freeShip });
    if (giftsOn) conf.tiers.forEach(function (t) { marks.push({ amount: t.amount, label: t.label || 'Free gift', on: st.sub >= t.amount }); });
    if (!marks.length) return '';
    var max = marks.reduce(function (m, x) { return Math.max(m, x.amount); }, 0);
    var fill = Math.min(st.sub / max, 1) * 100;

    var msgs = [];
    if (conf.freeShip > 0 && cart.total_price < conf.freeShip) {
      msgs.push('Spend <strong>' + money(conf.freeShip - cart.total_price) + '</strong> more for free shipping.');
    }
    if (giftsOn) {
      var hasGift = st.gifts.length > 0;
      if (!st.cur) {
        msgs.push('Spend <strong>' + money(st.next.amount - st.sub) + '</strong> more to unlock a free gift.');
      } else if (st.next) {
        msgs.push((hasGift ? '<b class="tsg-ok">Your free gift is in the cart.</b>' : '<b class="tsg-ok">You\'ve unlocked a free gift.</b> Pick 1 below.') +
          ' Spend <strong>' + money(st.next.amount - st.sub) + '</strong> more for more gift choices.');
      } else {
        msgs.push(hasGift ? '<b class="tsg-ok">Your free gift is in the cart.</b> Every gift is unlocked.' : '<b class="tsg-ok">Every gift is unlocked.</b> Pick any 1 gift below.');
      }
    } else if (!msgs.length) {
      msgs.push('<b class="tsg-ok">You\'ve unlocked free shipping.</b>');
    }

    var marksHtml = marks.map(function (m) {
      return '<span class="tsg-ms' + (m.on ? ' is-on' : '') + '" style="left:' + (m.amount / max * 100) + '%">' +
        '<i>' + (m.on ? ICON_CHECK : '') + '</i><em>' + money(m.amount).replace(/\.00$/, '') + '<small>' + esc(m.label) + '</small></em></span>';
    }).join('');

    return '<div class="tsg-bar"><p class="tsg-msg">' + msgs.join('<br>') + '</p>' +
      '<div class="tsg-track"><span class="tsg-fill" style="width:' + fill + '%"></span>' + marksHtml + '</div></div>';
  }

  function pickerHtml(cart, conf, st) {
    if (!conf.enabled || !conf.tiers.length || !st.cur) return '';
    var gift = st.gifts[0] || null;
    var seen = {};
    var list = [];
    conf.tiers.forEach(function (t) {
      t.products.forEach(function (p) {
        if (seen[p.id]) return;
        var avail = p.variants.filter(function (v) { return v.available; });
        if (!avail.length) return;
        seen[p.id] = true;
        list.push({ p: p, avail: avail, unlock: t.amount });
      });
    });
    if (!list.length) return '';

    var giftTitle = '';
    var cards = list.map(function (x) {
      var p = x.p;
      var locked = !st.cur || x.unlock > st.cur.amount;
      var selected = !!(gift && gift.product_id === p.id);
      var chosenId = selected ? gift.variant_id : x.avail[0].id;
      var chosen = x.avail.filter(function (v) { return v.id === chosenId; })[0] || x.avail[0];
      if (selected) giftTitle = p.title;
      var sel = '';
      if (!p.single && x.avail.length > 0) {
        sel = '<label class="tsg-sz"><span>Size</span><select data-ts-gift-variant' + (locked ? ' disabled' : '') + '>' +
          x.avail.map(function (v) { return '<option value="' + v.id + '"' + (v.id === chosen.id ? ' selected' : '') + '>' + esc(v.title) + '</option>'; }).join('') +
          '</select></label>';
      }
      var btn;
      if (locked) btn = '<span class="tsg-lock">' + ICON_LOCK + 'Unlocks at ' + money(x.unlock).replace(/\.00$/, '') + '</span>';
      else if (selected) btn = '<span class="tsg-b is-on">' + ICON_CHECK + 'Your gift</span>';
      else btn = '<button type="button" class="tsg-b" data-ts-gift-choose data-variant="' + chosen.id + '">' + (gift ? 'Switch' : 'Choose') + '</button>';
      return '<div class="tsg-card' + (selected ? ' is-sel' : '') + (locked ? ' is-lock' : '') + '" data-ts-gift-card>' +
        '<div class="tsg-ph">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="80" height="80">' : '') + '</div>' +
        '<div class="tsg-m"><p class="tsg-n">' + esc(p.title) + '</p><p class="tsg-w"><s>' + money(chosen.price) + '</s> <b>FREE</b></p>' + sel + '</div>' +
        btn + '</div>';
    }).join('');

    var head = gift ? ('Your free gift: ' + esc(giftTitle)) : esc(conf.heading || 'Choose your free gift');
    return '<details class="tsg-pk"' + (gift ? '' : ' open') + '>' +
      '<summary><span class="tsg-pk__h">' + ICON_GIFT + '<span>' + head + '</span></span><span class="tsg-pk__s">' + (gift ? 'Change' : 'Pick 1 per order') + ICON_CHEV + '</span></summary>' +
      '<div class="tsg-list">' + cards + '</div>' +
      (conf.foot ? '<p class="tsg-foot">' + esc(conf.foot) + '</p>' : '') + '</details>';
  }

  function draw(cart, conf, st) {
    document.querySelectorAll('[data-ts-gifts]').forEach(function (mount) {
      var open = null;
      var d = mount.querySelector('details.tsg-pk');
      if (d && mount.hasAttribute('data-ts-ready')) open = d.open;
      mount.innerHTML = barHtml(cart, conf, st) + pickerHtml(cart, conf, st);
      var nd = mount.querySelector('details.tsg-pk');
      if (nd && open !== null && st.gifts.length) nd.open = open;
      mount.setAttribute('data-ts-ready', '');
    });
  }

  /* ---------- main loop ---------- */

  function run() {
    if (busy) { pending = true; return; }
    var conf = config();
    if (!conf || !document.querySelector('[data-ts-gifts]') && !conf.enabled) return;
    busy = true;
    fetchCart().then(function (cart) {
      var st = getState(cart, conf);
      var fix = conf.enabled ? enforce(st) : Promise.resolve(false);
      return fix.then(function (changed) {
        if (!changed) return { cart: cart, st: st, changed: false };
        return fetchCart().then(function (c2) { return { cart: c2, st: getState(c2, conf), changed: true }; });
      });
    }).then(function (r) {
      lastCart = r.cart;
      draw(r.cart, conf, r.st);
      if (r.changed) redrawTheme();
    }).catch(function () {}).then(function () {
      busy = false;
      if (pending) { pending = false; schedule(); }
    });
  }

  // One redraw 60 ms after the first change that leaves an empty mount. Later changes do not push it back, so a page
  // that keeps changing (an animation, another script's loop) cannot hold the redraw off for good (B42; before, every
  // change restarted the 60 ms wait).
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; run(); }, 60);
  }

  function choose(btn) {
    var card = btn.closest('[data-ts-gift-card]');
    var select = card && card.querySelector('[data-ts-gift-variant]');
    var id = parseInt(select ? select.value : btn.getAttribute('data-variant'), 10);
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    busy = true;
    fetchCart().then(function (cart) {
      var updates = {};
      var any = false;
      cart.items.forEach(function (i) { if (isGift(i)) { updates[i.key] = 0; any = true; } });
      return (any ? getJSON(cartUrl + '/update.js', { updates: updates }) : Promise.resolve()).then(function () {
        var props = {};
        props[PROMO_KEY] = PROMO_VAL;
        return getJSON(cartUrl + '/add.js', { items: [{ id: id, quantity: 1, properties: props }] });
      });
    }).catch(function () {}).then(function () {
      busy = false;
      redrawTheme();
      schedule();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ts-gift-choose]');
    if (btn) { e.preventDefault(); choose(btn); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-ts-gift-variant]')) {
      var card = t.closest('[data-ts-gift-card]');
      if (card && card.classList.contains('is-sel')) {
        var fake = document.createElement('button');
        card.appendChild(fake);
        fake.setAttribute('data-variant', t.value);
        choose(fake);
      } else if (card) {
        var b = card.querySelector('[data-ts-gift-choose]');
        if (b) b.setAttribute('data-variant', t.value);
      }
    }
    if (t.matches && t.matches('[data-ts-note]')) {
      getJSON(cartUrl + '/update.js', { note: t.value });
    }
  });

  // Cart page: add the gift mount under the line items card and hide the quantity box on gift lines.
  // (Done here so the stock sections/main-cart.liquid file does not need editing.)
  function preparePage() {
    var section = document.querySelector('[data-section-type="cart"]');
    if (!section) return;
    if (!section.querySelector('[data-ts-gifts]')) {
      var table = section.querySelector('.line-item-table');
      var card = table && table.closest('.card');
      if (card) {
        var mount = document.createElement('div');
        mount.className = 'ts-gifts-mount ts-gifts-mount--page';
        mount.setAttribute('data-ts-gifts', 'page');
        card.parentNode.insertBefore(mount, card.nextSibling);
      }
    }
    section.querySelectorAll('.line-item__property').forEach(function (li) {
      if (li.textContent.replace(/\s+/g, ' ').trim() !== PROMO_KEY + ': ' + PROMO_VAL) return;
      var row = li.closest('.line-item');
      if (!row || row.classList.contains('ts-gift-row')) return;
      row.classList.add('ts-gift-row');
      row.querySelectorAll('.quantity-selector').forEach(function (q) {
        var span = document.createElement('span');
        span.className = 'ts-gift-qty';
        span.textContent = '1';
        q.parentNode.replaceChild(span, q);
      });
    });
  }

  // Redraw whenever the theme replaces the cart markup (fresh, empty mounts appear).
  var mo = new MutationObserver(function () {
    preparePage();
    if (document.querySelector('[data-ts-gifts]:not([data-ts-ready])')) schedule();
  });

  function start() {
    preparePage();
    mo.observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  window.tsCartGifts = { refresh: schedule, cart: function () { return lastCart; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/*
  Page lock guard (2026-10-21, B43 follow-up, with Nick's OK).
  theme.js locks page scrolling (html.is-locked, overflow-y hidden) when the slide-out cart opens, but its search bar
  removes that class 150 ms after any click anywhere on the page. So the lock flickered: the scroll bar vanished and came
  back and the page shifted sideways (Nick: "the scroll bar disappears for a split second and the whole site shifts").
  While the slide-out cart is open, this puts the lock back whenever something else removes it. The theme's own close
  still lifts it, because it hides the cart (aria-hidden true) before removing the class. The scrollbar-gutter rule at
  the top of ts-cart.css keeps the page from shifting while the scroll bar is gone.
*/
(function () {
  if (window.tsCartLock) return;
  window.tsCartLock = true;
  var html = document.documentElement;

  function cartOpen() {
    var mc = document.getElementById('mini-cart');
    return !!mc && mc.classList.contains('ts-cd') && mc.getAttribute('aria-hidden') === 'false';
  }

  new MutationObserver(function () {
    if (!html.classList.contains('is-locked') && cartOpen()) html.classList.add('is-locked');
  }).observe(html, { attributes: true, attributeFilter: ['class'] });
})();
